/**
 * ExtranetAuthProviderRoute — wrapper que lê :tenantSlug da URL e envolve
 * as rotas protegidas em ExtranetAuthProvider(tenantSlug).
 */
import { Outlet, useParams } from 'react-router-dom';
import { ExtranetAuthProvider } from '@/hooks/useExtranetAuth';

export function ExtranetAuthProviderRoute() {
  const { tenantSlug = '' } = useParams<{ tenantSlug: string }>();
  return (
    <ExtranetAuthProvider tenantSlug={tenantSlug}>
      <Outlet />
    </ExtranetAuthProvider>
  );
}
